module.exports = __webpack_public_path__ + "img/jk_ico.c97d0839.png";